import React, { useState } from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { Icon } from "components/common";
import OverlayDropdown from "components/common/OverlayDropdown";
import FilterConfiguration from "components/common/EntityFilters/FilterConfiguration";
const Container = styled.div`
  display: flex;
`;
const CenteredButton = styled(Button)`
  display: flex;
  align-items: center;
`;
const FilterValueButton = styled(CenteredButton)`
  &&& {
    text-decoration: ${({ $isConflicting }) => $isConflicting ? "line-through" : "none"};
  }
`;
const FilterValueDropdown = ({
  attribute,
  allActiveFilters,
  onChangeFilter,
  filterValueRenderer,
  filter,
  isConflicting
}) => {
  const [show, setShowDropdown] = useState(false);
  const { value, title } = filter;
  const _onToggle = () => {
    setShowDropdown((cur) => !cur);
  };
  const _onClose = () => {
    setShowDropdown(false);
  };
  const onSubmit = (newFilter) => {
    onChangeFilter(attribute.id, value, { value: newFilter.value, title: newFilter.title });
    _onToggle();
  };
  return /* @__PURE__ */ React.createElement(
    OverlayDropdown,
    {
      show,
      closeOnSelect: false,
      toggleChild: /* @__PURE__ */ React.createElement(
        FilterValueButton,
        {
          bsSize: "xsmall",
          title: "Change filter value",
          $isConflicting: isConflicting,
          disabled: isConflicting
        },
        filterValueRenderer ? filterValueRenderer(value, title) : title
      ),
      placement: "bottom",
      onToggle: _onToggle,
      onClose: _onClose,
      dropdownZIndex: 1050
    },
    /* @__PURE__ */ React.createElement(
      FilterConfiguration,
      {
        attribute,
        filterValueRenderer,
        onSubmit,
        filter,
        allActiveFilters
      }
    )
  );
};
const ActiveFilter = ({
  attribute,
  allActiveFilters,
  filter,
  filterValueRenderer,
  onDeleteFilter,
  onChangeFilter,
  isConflicting
}) => {
  const { value, title } = filter;
  const onChangeBooleanValue = () => {
    if (attribute.type === "BOOLEAN") {
      const oppositeFilterOption = attribute.filter_options.find(({ value: optionVal }) => optionVal !== value);
      onChangeFilter(attribute.id, value, { value: oppositeFilterOption.value, title: oppositeFilterOption.title });
    }
  };
  return /* @__PURE__ */ React.createElement(Container, { className: "btn-group", "data-testid": `${attribute.id}-filter-${value}` }, attribute.type === "BOOLEAN" && /* @__PURE__ */ React.createElement(
    FilterValueButton,
    {
      bsSize: "xsmall",
      onClick: isConflicting ? void 0 : onChangeBooleanValue,
      title: "Change filter value",
      $isConflicting: isConflicting,
      disabled: isConflicting
    },
    filterValueRenderer ? filterValueRenderer(value, title) : title
  ), attribute.type !== "BOOLEAN" && /* @__PURE__ */ React.createElement(
    FilterValueDropdown,
    {
      onChangeFilter,
      attribute,
      filter,
      allActiveFilters,
      filterValueRenderer,
      isConflicting
    }
  ), /* @__PURE__ */ React.createElement(CenteredButton, { bsSize: "xsmall", onClick: () => onDeleteFilter(attribute.id, value), title: "Delete filter" }, /* @__PURE__ */ React.createElement(Icon, { name: "close" })));
};
export default ActiveFilter;
